import { Form } from 'antd';
import EmployeeSelect from 'app/components/Select/EmployeeSelect/EmployeeSelect';
import { FC } from 'react';
import { getEmployeeFormItemName } from '../AddRouteToTaskDrawer/AddRouteToTaskDrawer.helpers';

interface IProps {
  routeId: number;
}

const RouteEmployeeSelect: FC<IProps> = ({ routeId }) => {
  return (
    <Form.Item
      name={getEmployeeFormItemName(routeId)}
      style={{ marginBottom: 0 }}
    >
      <EmployeeSelect
        allowClear
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const label = (option?.label as string)?.toLowerCase();
          return label?.includes(input.toLowerCase());
        }}
        style={{ width: 184 }}
      />
    </Form.Item>
  );
};

export default RouteEmployeeSelect;
